<template>
    <div>
        <slot
            :can_publish="can_publish"
            :published="published"
            :annotations_by_section="annotationsBySection"
            :getAnnotationCounts="getAnnotationCounts"
            @updateListBuild="updateListBuild"
        />
    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: {
        initial_published: {},
        user_id: {},
        for_profile: {},
    },

    data() {
        return {
            can_publish: false,
            published: this.initial_published,
            annotationsBySection: {},
            user_id: null,
        }
    },

    methods: {
        updatedSelectedReports(reports) {
            this.can_publish = reports.length > 0;

            if (! reports.length) {
                this.unpublishReports();
            }
        },
        unpublishReports() {
            axios.put('/myprofile', { published: 0 })
                .then(response => {
                    this.published = false;
                })
                .catch(error => {
                    console.log(error.response);
                });
        },
        getAnnotationCounts() {
            if (! this.user_id) {
                return;
            }

            axios.get('/users/' + this.user_id + '/annotations', {
                params: {
                    for_profile: this.for_profile,
                }
            })
            .then(response => {
                if (response.data) {
                    this.annotationsBySection = this.groupBy(response.data, 'report_section_id');
                }
            })
        },
        groupBy(objectArray, property) {
            return objectArray.reduce(function (acc, obj) {
                let key = obj[property];

                if (! acc[key]) {
                    acc[key] = []
                }

                acc[key].push(obj);
                return acc;
            }, {});
        },
    },

    created() {
        this.$on('updatedSelectedReports', this.updatedSelectedReports);
        this.getAnnotationCounts();
    },
}
</script>
